import { useContext } from 'react'

import { __RouterContext, matchPath } from 'react-router-dom'

export default function useRouter (options = {}) {
  const context = useContext(__RouterContext)
  const location = options.location || context.location
  const match = options.path
    ? matchPath(location.pathname, options)
    : context.match

  return { ...context, location, match }
}
